export const fontSize = {
  h1: '64px',
  h2: '48px',
  h3: '24px',
  xxl: '22px',
  xl: '20px',
  lg: '18px',
  mg: '16px',
  sm: '14px',
  xs: '12px',
};

export const lineHeight = {
  h1: '64px',
  h2: '48px',
  h3: '33px',
  xxl: '32px',
  xl: '28px',
  lg: '26px',
};

export const fontWeight = {
  extraBold: 800,
  bold: 700,
  regular: 400,
  semiBold: 400,
};
